import React from 'react'
import DivTable from '../DivTable'
import InnerTable from '../Table'
import Scrolling from './Scrolling'
import RenderTable from '../RenderTable'
import StepScrolling from './StepScrolling'
import InfinityScroll from './InfinityScroll'

const ScrollRender = ({
    enableScrolling,
    columns,
    divTable,
    options,
    hasSorting,
    handleChange,
    dataList,
    setDataListFromItem,
    customProps,
    isStepScrolling,
    rowHeight,
    setDataListToDisplay,
    setPageNumber,
    loading,
    headerHeight,
    pageNumberFromPager,
    dataListToDisplay,
    theme,
    isInfinityScroll, scrollPosition, setScrollPosition, isDynamicColumns, exportDataModel, customCardView
}) => {
    let renderTable = {
        columns, options, hasSorting, handleChange, dataList, setDataListFromItem,
        setPageNumber,
        customProps, theme, divTable, dataListToDisplay, isDynamicColumns, exportDataModel, customCardView
    }
    let scrollProps = {
        totalCount: dataList.totalCount,
        pageSize: dataList.pageSize, rowHeight,
        currentPage: dataList.pageNumber,
        dataList: dataList.data,
        callGetData: handleChange,
        setDataListToDisplay,
        setPageNumber,
        pending: loading,
        headerHeight,
        pageNumberFromPager,
        dataListToDisplay, scrollPosition, setScrollPosition, exportDataModel, customCardView
    }

    return (
        <>
            {!enableScrolling && <>
                {columns.length > 0 ?
                    <RenderTable {...renderTable} />
                    :
                    <h2 className='text-center color-gray'>The table has not any columns</h2>}
            </>
            }
            {!isStepScrolling && enableScrolling && !isInfinityScroll &&
                <Scrolling {...scrollProps}  >
                    {columns.length > 0 ?
                        <>
                            <RenderTable {...renderTable} />
                        </> :
                        <h2 className='text-center color-gray'>The table has not any columns</h2>}
                </Scrolling>}
            {isStepScrolling && enableScrolling && !isInfinityScroll &&
                <StepScrolling  {...scrollProps} >
                    {columns.length > 0 ?
                        <RenderTable {...renderTable} /> :
                        <h2 className='text-center color-gray'>The table has not any columns</h2>}
                </StepScrolling>}
            {enableScrolling && isInfinityScroll &&
                <InfinityScroll  {...scrollProps} >
                    {columns.length > 0 ?
                        <RenderTable {...renderTable} /> :
                        <h2 className='text-center color-gray'>The table has not any columns</h2>}
                </InfinityScroll>}
        </>
    )
}

export default ScrollRender
